import Vue from 'vue'
import Home from "./components/content/Home.vue"
import MenuDetails from "./components/menu/MenuDetails.vue"
import MenuDetailsNew from "./components/menu/MenuDetailsNew.vue"
import FiaIntelligenceDetails from "./components/menu/fia-intelligence-details/FiaIntelligenceDetails.vue"
import Content from "./components/content/Content.vue"
import Search from "./components/content/search/Search.vue"
import Nfis from "./components/content/nfis/Nfis.vue"
import LegalEntityProfile from "./components/content/business-entities-register/LegalEntityProfile.vue"
import LegalEntityProfilePublic from "./components/content/business-entities-register/LegalEntityProfilePublic.vue"
import BusinessEntitiesRegister from "./components/content/business-entities-register/BusinessEntitiesRegister.vue"
import UniqueAccountsRegister from "./components/content/uniqueAccountsRegister/UniqueAccountsRegister"
import Contact from "./components/content/contact/Contact.vue"
import BusinessUnits from "./components/content/contact/BusinessUnits.vue"
import FinancialReportControl from "./components/content/rfi/FinancialReportControl.vue"
import LegalEntityDocumentsIndex from "./components/content/legal-entity-documents/Index.vue"
import FinancialReportsTemplates from "./components/content/financial-reports-templates/Index.vue"
import FinancialReportsTemplates22 from "./components/content/financial-reports-templates/Index2022.vue"
import FinancialReportControl2022 from "./components/content/rfi/FinancialReportControl2022.vue"

import VueRouter from "vue-router"
import i18n from './i18n'
import AboutUs from './components/content/about-us/AboutUs.vue'
import OtherServices from './components/content/other-services/OtherServices.vue'
import NewsAll from './components/content/NewsAll.vue'
import InfographicsAll from './components/content/infographics-new/InfographicsAll.vue'
import NewsContentNew from './components/content/NewsContentNew.vue'
import ContentNew from './components/content/ContentNew.vue'
import OldForeignCurrencySavings from './components/content/old-foreign-currency-savings/OldForeignCurrencySavings.vue'
import PublicationsNew from './components/content/publications/PublicationsNew.vue'
import StandardOverview from './components/content/analyses/StandardOverview.vue'
import CreditRating from './components/content/analyses/CreditRating.vue'
import PriceList from './components/content/prices/PriceList.vue'
import Internship from './components/content/internship/Internship.vue'
import Survey from './components/content/survey/Survey.vue'
import RRFL from './components/content/rrfl/RRFL.vue'
import CustomMap from './components/content/map/CustomMap.vue'
import FinancialOverviewNonprofitOrganizations from './components/content/analyses/FinancialOverviewNonprofitOrganizations.vue'
import ApiDocs from './components/content/api-docs/ApiDocs.vue'
//import { store } from "./store/store.js"

Vue.use(VueRouter);

export default new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes:[
        {
            path: "/",
            redirect: `${i18n.locale}`,
            component: Home,
        },
        {
            path: "/:lang",
            component: {
                render(c) { return c('router-view') }
            },
            children: [
                {
                    path: "",
                    component: Home,
                    meta: {
                        allowAnonymous: true
                    }
                },
                /*NEW WEB*/
                {
                    path: "details/:id/:slug",
                    component: MenuDetailsNew,
                    name: "menuDetailsNew",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "fia-intelligence/:id/:slug",
                    component: FiaIntelligenceDetails,
                    name: "fiaIntelligenceDetails",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "o-nama-new",
                    component: AboutUs,
                    name: "o-nama-new",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "about-us-new",
                    component: AboutUs,
                    name: "about-us-new",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "praksa",
                    component: Internship,
                    name: "praksa",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "internship",
                    component: Internship,
                    name: "internship",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "anketa",
                    component: Survey,
                    name: "anketa",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "survey",
                    component: Survey,
                    name: "survey",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "stara-devizna-stednja",
                    component: OldForeignCurrencySavings,
                    name: "stara-devizna-stednja",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "old-foreign-currency-savings",
                    component: OldForeignCurrencySavings,
                    name: "old-foreign-currency-savings",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "ostale-usluge",
                    component: OtherServices,
                    name: "ostale-usluge",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "other-services",
                    component: OtherServices,
                    name: "other-services",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "sve-novosti",
                    component: NewsAll,
                    name: "sve-novosti",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "all-news",
                    component: NewsAll,
                    name: "all-news",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "sve-infografike",
                    component: InfographicsAll,
                    name: "sve-infografike",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "all-infographics",
                    component: InfographicsAll,
                    name: "all-infographics",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "news-content/:id",
                    component: NewsContentNew,
                    name: "news-content",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "novost-sadrzaj/:id",
                    component: NewsContentNew,
                    name: "news-content",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "content/:id/:slug",
                    component: ContentNew,
                    name: "contentNew",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "publikacije",
                    component: PublicationsNew,
                    name: "publikacije",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "publications",
                    component: PublicationsNew,
                    name: "publications",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "credit-rating",
                    component: CreditRating,
                    name: "credit-rating",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "bonitetna-ocjena",
                    component: CreditRating,
                    name: "bonitetna-ocjena",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "standard-overview",
                    component: StandardOverview,
                    name: "standard-overview",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "standardni-pregled",
                    component: StandardOverview,
                    name: "standardni-pregled",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "price-list",
                    component: PriceList,
                    name: "price-list",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "cjenovnik",
                    component: PriceList,
                    name: "cjenovnik",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "cjenik",
                    component: PriceList,
                    name: "cjenik",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "registar-racuna-fizickih-lica",
                    component: RRFL,
                    name: "registar-racuna-fizickih-lica",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "register-of-accounts-of-natural-persons",
                    component: RRFL,
                    name: "register-of-accounts-of-natural-persons",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "interaktivna-mapa",
                    component: CustomMap,
                    name: "interaktivna-mapa",
                    props: true,
                    meta: {
                        allowAnonymous: true 
                    }
                },
                {
                    path: "interactive-map",
                    component: CustomMap,
                    name: "interactive-map",
                    props: true,
                    meta: {
                        allowAnonymous: true 
                    }
                },
                {
                    path: "finansijski-pregled-za-neprofitne-organizacije",
                    component: FinancialOverviewNonprofitOrganizations,
                    name: "finansijski-pregled-za-neprofitne-organizacije",
                    props: true,
                    meta: {
                        allowAnonymous: true 
                    }
                },
                {
                    path: "financijski-pregled-za-neprofitne-organizacije",
                    component: FinancialOverviewNonprofitOrganizations,
                    name: "financijski-pregled-za-neprofitne-organizacije",
                    props: true,
                    meta: {
                        allowAnonymous: true 
                    }
                },
                {
                    path: "financial-overview-of-nonprofit-organizations",
                    component: FinancialOverviewNonprofitOrganizations,
                    name: "financial-overview-of-nonprofit-organizations",
                    props: true,
                    meta: {
                        allowAnonymous: true 
                    }
                },
                /*NEW WEB*/
                {
                    path: "details/:id/:slug",
                    component: MenuDetails,
                    name: "menuDetails",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "content/:id/:slug",
                    component: Content,
                    name: "content",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "search",
                    component: Search,
                    name: "search",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "nfis",
                    component: Nfis,
                    name: "nfis",
                    props: true,
                    meta: {
                        allowAnonymous: false    //switch to false
                    }
                },
                //{
                //    path: "business-entities-profile",
                //    component: BusinessEntitiesRegister,
                //    name: "business-entities-profile",
                //    props: true,
                //    meta: {
                //        allowAnonymous: false    //switch to false
                //    }
                //},
               {
                    path: "profil-pravnih-lica",
                    component: BusinessEntitiesRegister,
                    name: "profil-pravnih-lica",
                    props: {isPublic:false},
                    meta: {
                        allowAnonymous: false    //switch to false
                    }
                },
                {
                    path: "profil-pravnih-lica/:id",
                    component: LegalEntityProfile,
                    name: "legalEntityProfile",
                    props: true,
                    meta: {
                        allowAnonymous: false    //switch to false
                    }
                },
                {
                    path: "profil-javnih-preduzeca",
                    component: BusinessEntitiesRegister,
                    name: "profil-javnih-preduzeca",
                    props: {isPublic:true},
                    meta: {
                        allowAnonymous: false    //switch to false
                    }
                },
                {
                    path: "profil-javnih-preduzeca/:id",
                    component: LegalEntityProfilePublic,
                    name: "legalEntityProfilePublic",
                    props: true,
                    meta: {
                        allowAnonymous: false    //switch to false
                    }
                },
                //{
                //    path: "registar-poslovnih-lica/:id",
                //    component: LegalEntityProfile,
                //    name: "legalEntityProfile",
                //    props: true,
                //    meta: {
                //        allowAnonymous: false    //switch to false
                //    }
                //},
                {
                    path: "jedinstveni-registar-racuna",
                    component: UniqueAccountsRegister,
                    name: "jedinstveni-registar-racuna",
                    props: true,
                    meta: {
                        allowAnonymous: false    //switch to false
                    }
                },
                {
                    path: "unique-accounts-register",
                    component: UniqueAccountsRegister,
                    name: "unique-accounts-register",
                    props: true,
                    meta: {
                        allowAnonymous: false    //switch to false
                    }
                },
                {
                    path: "pre-bankruptcy-and-bankruptcy-proceedings",
                    component: LegalEntityDocumentsIndex,
                    name: "pre-bankruptcy-and-bankruptcy-proceedings",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "predstecajni-i-stecajni-postupci",
                    component: LegalEntityDocumentsIndex,
                    name: "predstecajni-i-stecajni-postupci",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                     // {
                //     path: "financial-reports-templates",
                //     component: FinancialReportsTemplates,
                //     name: "financial-reports-templates",
                //     props: true,
                //     meta: {
                //         allowAnonymous: true
                //     }
                // },
                // {
                //     path: "predlosci-finansijskih-izvjestaja",
                //     component: FinancialReportsTemplates,
                //     name: "predlosci-finansijskih-izvjestaja",
                //     props: true,
                //     meta: {
                //         allowAnonymous: true
                //     }
                // },
                // {
                //     path: "financial-reports-templates-22",
                //     component: FinancialReportsTemplates22,
                //     name: "financial-reports-templates-22",
                //     props: true,
                //     meta: {
                //         allowAnonymous: true
                //     }
                // },
                // {
                //     path: "financial-reports-templates-22",
                //     component: FinancialReportsTemplates22,
                //     name: "financial-reports-templates-hr",
                //     props: true,
                //     meta: {
                //         allowAnonymous: true
                //     }
                // },
                  {
                    path: "financial-reports-templates",
                    component: FinancialReportsTemplates22,
                    name: "financial-reports-templates",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "predlosci-finansijskih-izvjestaja",
                    component: FinancialReportsTemplates22,
                    name: "predlosci-finansijskih-izvjestaja",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "financial-reports-templates-old",
                    component: FinancialReportsTemplates,
                    name: "financial-reports-templates-old",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "financial-reports-templates-old",
                    component: FinancialReportsTemplates,
                    name: "financial-reports-templates-hr",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "contact-us",
                    component: Contact,
                    name: "contact-us",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "kontaktirajte-nas",
                    component: Contact,
                    name: "kontaktirajte-nas",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "locations-and-business-units",
                    component: BusinessUnits,
                    name: "locations-and-business-units",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "lokacije-i-poslovne-jedinice",
                    component: BusinessUnits,
                    name: "lokacije-i-poslovne-jedinice",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                 // {
                //     path: "kontrola-finansijskih-izvjestaja",
                //     component: FinancialReportControl,
                //     name: "kontrola-finansijskih-izvjestaja",
                //     props: true,
                //     meta: {
                //         allowAnonymous: true
                //     }
                // },
                // {
                //     path: "kontrola-financijskih-izvjestaja",
                //     component: FinancialReportControl,
                //     name: "kontrola-financijskih-izvjestaja",
                //     props: true,
                //     meta: {
                //         allowAnonymous: true
                //     }
                // },
                // {
                //     path: "financial-reports-control",
                //     component: FinancialReportControl,
                //     name: "financial-reports-control",
                //     props: true,
                //     meta: {
                //         allowAnonymous: true
                //     }
                // },
                // {
                //     path: "financial-reports-control-2022",
                //     component: FinancialReportControl2022,
                //     name: "financial-reports-control-2022",
                //     props: true,
                //     meta: {
                //         allowAnonymous: true
                //     }
                // },
                // {
                //     path: "kontrola-finansijskih-izvjestaja-2022",
                //     component: FinancialReportControl2022,
                //     name: "kontrola-finansijskih-izvjestaja-2022",
                //     props: true,
                //     meta: {
                //         allowAnonymous: true
                //     }
                // },
                // {
                //     path: "kontrola-financijskih-izvjestaja-2022",
                //     component: FinancialReportControl2022,
                //     name: "kontrola-financijskih-izvjestaja-2022",
                //     props: true,
                //     meta: {
                //         allowAnonymous: true
                //     }
                // },
                {
                    path: "kontrola-finansijskih-izvjestaja",
                    component: FinancialReportControl2022,
                    name: "kontrola-finansijskih-izvjestaja",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "kontrola-financijskih-izvjestaja",
                    component: FinancialReportControl2022,
                    name: "kontrola-financijskih-izvjestaja",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "financial-reports-control",
                    component: FinancialReportControl2022,
                    name: "financial-reports-control",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "financial-reports-control-old",
                    component: FinancialReportControl,
                    name: "financial-reports-control-old",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "kontrola-finansijskih-izvjestaja-old",
                    component: FinancialReportControl,
                    name: "kontrola-finansijskih-izvjestaja-old",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "kontrola-financijskih-izvjestaja-old",
                    component: FinancialReportControl,
                    name: "kontrola-financijskih-izvjestaja-old",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
                {
                    path: "api-docs",
                    component: ApiDocs,
                    name: "api-docs",
                    props: true,
                    meta: {
                        allowAnonymous: true
                    }
                },
            ]
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
      }
})
